export default "\r\n<app-payment-method-list></app-payment-method-list>\r\n\r\n\r\n";